import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export default function ConfirmDelete({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
  loading,
  testIdPrefix,
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        className="bg-white border-[#E5E2DC] rounded-2xl"
        data-testid={`${testIdPrefix}-confirm-dialog`}
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading text-2xl tracking-tight text-[#1A1D1A]">
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-[#5C635A] leading-relaxed">
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            data-testid={`${testIdPrefix}-cancel`}
            className="bg-transparent border-[#E5E2DC] text-[#1A1D1A] hover:bg-[#F2F0EA] hover:text-[#1A1D1A]"
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={loading}
            onClick={onConfirm}
            data-testid={`${testIdPrefix}-confirm`}
            className="bg-[#9C6A53] hover:bg-[#8B5A48] text-white rounded-lg"
          >
            {loading ? "Deleting..." : "Delete"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
